import { ENTFALLENE_ANTWORT_KEYS, HISTORISCHE_ANTWORT_KEYS } from "./answerKeys.js";
import { documentRefs } from "./fieldTypes.js";
import { isAnswerFilled } from "./visibility.js";
export const collectFields = (schema) => {
    const fields = [];
    for (const section of schema.sections) {
        for (const subStep of section.subSteps) {
            for (const question of subStep.questions) {
                fields.push(...(question.fields ?? (question.field ? [question.field] : [])));
                fields.push(...(question.followUpFields ?? []));
            }
        }
    }
    return fields;
};
export function validateFormAnswers(schema, answers) {
    const fields = collectFields(schema);
    const knownKeys = new Set(fields.map((field) => field.key));
    const invalidValues = [];
    for (const field of fields) {
        if (field.type !== "documents")
            continue;
        const value = answers[field.key];
        // Nie befuellt ⇒ nichts zu bemaengeln; `[]` ist eine gueltige leere Liste.
        if (!isAnswerFilled(value))
            continue;
        if (!Array.isArray(value)) {
            invalidValues.push({
                key: field.key,
                reason: `Dateiliste erwartet, gespeichert ist ${typeof value}`,
            });
            continue;
        }
        const brauchbar = documentRefs(value).length;
        if (brauchbar < value.length) {
            invalidValues.push({
                key: field.key,
                reason: `${value.length - brauchbar} von ${value.length} Eintraegen sind keine Dokument-Referenzen`,
            });
        }
    }
    return {
        // Zwei Sorten Alt-Keys zaehlen nicht als unbekannt, weil sie in
        // Bestands-Antwortsaetzen stecken und das Portal einen Satz mit
        // unbekannten Keys komplett zurueckweist:
        //  - Fragen, die aus dem Schema geflogen sind (ENTFALLENE_ANTWORT_KEYS),
        //  - Keys, die durch die Umbenennung "ein Key pro Frage" ersetzt wurden
        //    (HISTORISCHE_ANTWORT_KEYS). Ohne sie koennte ein Kunde ein vor der
        //    Umbenennung angefangenes Formular weder weiter ausfuellen noch
        //    abgeben.
        unknownKeys: Object.keys(answers).filter((key) => !knownKeys.has(key) &&
            !ENTFALLENE_ANTWORT_KEYS.has(key) &&
            !(key in HISTORISCHE_ANTWORT_KEYS)),
        invalidValues,
    };
}
